import { createAction, props } from '@ngrx/store';
import { GeneralHistoryPersonalCompleteModel } from 'src/app/model/general/history-personal-complete';
import { GeneralHistoryViewModel } from 'src/app/model/general/history.view';

const historyLabels = {
  SET_PERSON_ID: 'HISTORY_SET_PERSON_ID',
  SET_SAVING: 'HISTORY_SET_SAVING',
  SET_PESONAL_HISTORIES: 'HISTORY_SET_PESONAL_HISTORIES',
  SET_PESONAL_COMPLETE_HISTORY: 'HISTORY_SET_PESONAL_COMPLETE_HISTORY',
  SET_FAMILY_HISTORIES: 'HISTORY_SET_FAMILY_HISTORIES',
  ADD_TO_SAVED: 'HISTORY_ADD_TO_SAVED',
  SET_SAVE: 'HISTORY_SET_SAVE',
  SET_ALL_DEFAULT: 'HISTORY_SET_ALL_DEFAULT',
};

export const historyActions = {
  setPersonIdAction: createAction(
    historyLabels.SET_PERSON_ID,
    props<{ personId: number }>()
  ),
  setSavingAction: createAction(
    historyLabels.SET_SAVING,
    props<{ saving: boolean }>()
  ),
  setPersonalHistoriesAction: createAction(
    historyLabels.SET_PESONAL_HISTORIES,
    props<{ personalHistories: GeneralHistoryViewModel[] }>()
  ),
  setPersonalCompleteHistoryAction: createAction(
    historyLabels.SET_PESONAL_COMPLETE_HISTORY,
    props<GeneralHistoryPersonalCompleteModel>()
  ),
  setFamilyHistoriesAction: createAction(
    historyLabels.SET_FAMILY_HISTORIES,
    props<{ familyHistories: GeneralHistoryViewModel[] }>()
  ),
  addToSavedAction: createAction(
    historyLabels.ADD_TO_SAVED,
    props<{ value: number; hasComplete: boolean }>()
  ),
  setSaveAction: createAction(
    historyLabels.SET_SAVE,
    props<{ save: boolean }>()
  ),
  setAllDefaultAction: createAction(
    historyLabels.SET_ALL_DEFAULT,
    props<any>()
  ),
};
